import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";

export type InputSelectV2Props = {
  name: string;
  label: string;
  options: any[];
  rules?: any;
  optionLabel?: string;
  optionValue?: string;
  size?: "small" | "medium" | undefined;
  onChange?: (event: SelectChangeEvent, child?: ReactNode) => void;
  [x: string]: any;
};

export const InputSelectV2 = ({
  name,
  label,
  options,
  optionLabel,
  optionValue,
  size,
  rules,
  onChange,
  ...props
}: InputSelectV2Props) => {
  const { control, formState } = useFormContext();

  const errors = formState?.errors[name]
    ? formState.errors[name]?.message?.toString()
    : "";

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <FormControl fullWidth size={size} error={errors ? true : false}>
            <InputLabel id="demo-simple-select" required={props.required ?? false}>{label}</InputLabel>
            <Select
              labelId="demo-simple-select"
              label={label}
              value={field.value ?? ""}
              onChange={(event, child) => {
                field.onChange(event.target.value);
                onChange && onChange(event, child);
              }}
              {...props}
            >
              {options.map((option, index) => {
                return (
                  <MenuItem value={option[optionValue ?? "value"]} key={index}>
                    {option[optionLabel ?? "label"]}
                  </MenuItem>
                );
              })}
            </Select>
            {errors && <FormHelperText>{errors}</FormHelperText>}
          </FormControl>
        );
      }}
      rules={rules}
    />
  );
};
